import { useTheme } from '@flik/shared/components';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import MagicModal from '../magic/components/MagicModal';

const LandingPage: React.FC = () => {
  const { provideTailwind } = useTheme();
  const navigate = useNavigate();
  const [showSignIn, setShowSignIn] = useState(false);

  const handleSignInClick = () => {
    setShowSignIn(true);
  };

  const handleLearnMoreClick = () => {
    navigate('/get-started');
  };

  return (
    <div className={`w-full min-h-screen ${provideTailwind('bg-primary')}`}>
      {/* Always show NavBar */}
      <NavBar />

      <div className="max-w-4xl mx-auto px-8 py-16">
        {/* Hero section with specific height for scroll calculation */}
        <div
          className="text-center mb-16 h-48 flex flex-col justify-center"
          id="hero-section"
        >
          <h1
            className={`text-6xl font-bold mb-6 ${provideTailwind(
              'text-primary',
            )}`}
          >
            Welcome to Flik
          </h1>
          <p className={`text-xl mb-8 ${provideTailwind('text-secondary')}`}>
            Your intelligent productivity assistant
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-6 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-xl font-semibold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Smart Search
            </h3>
            <p className={provideTailwind('text-secondary')}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-6 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-xl font-semibold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Quick Actions
            </h3>
            <p className={provideTailwind('text-secondary')}>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-6 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-xl font-semibold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Seamless Integration
            </h3>
            <p className={provideTailwind('text-secondary')}>
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-pink-500 to-purple-600 p-8 rounded-lg text-white text-center">
          <h2 className="text-3xl font-bold mb-4">Get Started Today</h2>
          <p className="text-lg mb-6">
            Experience the power of intelligent productivity with Flik's
            advanced search and action capabilities.
          </p>
          <button
            onClick={handleLearnMoreClick}
            className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Learn More
          </button>
        </div>

        <div className="mt-16 text-center">
          <h2
            className={`text-3xl font-bold mb-8 ${provideTailwind(
              'text-primary',
            )}`}
          >
            Features
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="text-left">
              <h4
                className={`text-xl font-semibold mb-3 ${provideTailwind(
                  'text-primary',
                )}`}
              >
                Advanced Search
              </h4>
              <p className={`${provideTailwind('text-secondary')} mb-4`}>
                Excepteur sint occaecat cupidatat non proident, sunt in culpa
                qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
            <div className="text-left">
              <h4
                className={`text-xl font-semibold mb-3 ${provideTailwind(
                  'text-primary',
                )}`}
              >
                Custom Actions
              </h4>
              <p className={`${provideTailwind('text-secondary')} mb-4`}>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium.
              </p>
            </div>
          </div>
        </div>

        {/* Additional content to make scroll effect more noticeable */}
        <div className="mt-16 space-y-8">
          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              More Content Section
            </h3>
            <p className={`${provideTailwind('text-secondary')} mb-4`}>
              This section provides additional content to demonstrate the scroll
              effect. As you scroll down, you'll notice how the magic search bar
              naturally moves up and then becomes fixed at the top of the
              screen.
            </p>
            <p className={provideTailwind('text-secondary')}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Another Section
            </h3>
            <p className={`${provideTailwind('text-secondary')} mb-4`}>
              Continue scrolling to see the magic search bar stick to the top of
              the screen. This creates a natural and intuitive user experience
              where the search functionality is always accessible.
            </p>
            <p className={provideTailwind('text-secondary')}>
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Final Section
            </h3>
            <p className={provideTailwind('text-secondary')}>
              This is the final section of the landing page. By now, the magic
              search bar should be fixed at the top of the screen, providing
              easy access to search functionality while browsing the content
              below.
            </p>
          </div>

          {/* Extra content to ensure scrolling */}
          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Extra Content 1
            </h3>
            <p className={provideTailwind('text-secondary')}>
              More content to ensure the page is scrollable and the magic bar
              can become sticky.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Extra Content 2
            </h3>
            <p className={provideTailwind('text-secondary')}>
              Even more content to guarantee scrolling behavior works properly.
            </p>
          </div>

          <div
            className={`${provideTailwind(
              'bg-secondary',
            )} p-8 rounded-lg shadow-lg`}
          >
            <h3
              className={`text-2xl font-bold mb-4 ${provideTailwind(
                'text-primary',
              )}`}
            >
              Extra Content 3
            </h3>
            <p className={provideTailwind('text-secondary')}>
              Final extra content to make sure the page is definitely tall
              enough to scroll.
            </p>
          </div>
        </div>
      </div>

      {/* MagicModal with initialHeight for scroll-then-pin behavior */}
      <MagicModal
        onSignInClick={handleSignInClick}
        showSignIn={showSignIn}
        initialHeight={280}
      />
    </div>
  );
};

export default LandingPage;
